'use strict';

wbApp.controller('OnlineMeetingsRecordingsCtrl', ['$scope', '$q', '$modal', '$window', '$translate', 'onlineMeetingsSvc',
function ($scope, $q, $modal, $window, $translate, onlineMeetingsSvc) {

    $scope.onlineMeetingsRecordings = [];

    $scope.$on('selectedOnlineMeetingChanged', function (e, onlineMeetingInd) {
        if (!!onlineMeetingInd) {
            onlineMeetingsSvc.getById(onlineMeetingInd.meeting.id).$promise.then(function (onlineMeetingDetail) {
                $scope.onlineMeetingsRecordings = onlineMeetingDetail.recordings;
            })
        } else {
            $scope.onlineMeetingsRecordings = [];
        }
    });

    $scope.onlineMeetingsRecordingsGridSettings = {
        name: 'onlineMeetingsRecordings',
        columns: [
            {
                dataField: 'url',
                caption: $translate.instant('TXT_HUMAN_NAME'),
                dataType: 'string',
                cellTemplate: function (cellElement, cellInfo) {
                    $('<a href="' + cellInfo.data.url + '" target="_blank">' + cellInfo.data.url + '</a>').appendTo(cellElement);
                },
            },
            { dataField: 'startedAtUtc', caption: $translate.instant('TXT_LBL_START_DATE'), dataType: 'datetime', format: { datetime: 'short' }, width: '120px', sortOrder: 'asc' },
            { dataField: 'endedAteUtc', caption: $translate.instant("TXT_LBL_END_DATE"), dataType: 'datetime', format: { datetime: 'short' }, width: '120px' },

        ],
    }

}]);
